import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box, Typography, CircularProgress, Card, CardMedia, CardContent, useMediaQuery,
  useTheme, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions, Button,
} from '@mui/material';
import { Link } from "react-router-dom";
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import SingleLogin from "../../../../../helper/bootcampSinglelogin";
import bootcamp1 from "../../../../../assets/bootComps/aimlbootcamp1batch1.webp";
import bootcamp2 from "../../../../../assets/bootComps/aimlbootcamp2batch1.webp";
import { LearnersSubscription, LearnersMentorFeedback } from "../../../../../helper/base_url";

const SearchLearnerTrans = () => {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [rating, setRating] = useState('');
  const [submitStatus, setSubmitStatus] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${LearnersSubscription}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setPaymentStatus(response.data.paymentStatus);
        //console.log("data", response.data.paymentStatus)
      } catch (err) {
        if (err.response) {
          setError(err.response.data.message || 'Something went wrong');
        } else {
          setError('Server error');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTransaction();
  }, []);

  const handleClose = () => setOpen(false);

  const handleFeedbackSubmit = async () => {
    try {
      const token = localStorage.getItem('token');
      const mentorId = paymentStatus?.bootcamp1mentorid || paymentStatus?.bootcamp2mentorid;
      const batchCode = paymentStatus?.bootcamp1 || paymentStatus?.bootcamp2;

      if (!mentorId || !batchCode) {
        setSubmitStatus('Mentor or batch information not found.');
        return;
      }

      await axios.post(
        `${LearnersMentorFeedback}/${mentorId}/${batchCode}`,
        { feedbackMessage, rating },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSubmitStatus('Feedback submitted successfully.');
      setSnackOpen(true);
      handleClose();
      setFeedbackMessage('');
      setRating('5');
    } catch (error) {
      //console.error(error);
      setSubmitStatus('Failed to submit feedback.');
      setSnackOpen(true);
    }
  };

  
  const renderStars = (value) => {
    const fullStars = Math.floor(value);
    const hasHalfStar = value - fullStars >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    const stars = [];
    for (let i = 0; i < fullStars; i++) {
      stars.push(<StarIcon key={`full-${i}`} sx={{ color: '#e77c0c' }} />);
    }
    if (hasHalfStar) {
      stars.push(<StarHalfIcon key="half" sx={{ color: '#e77c0c' }} />);
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<StarBorderIcon key={`empty-${i}`} sx={{ color: '#e77c0c' }} />);
    }

    return stars;
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  return (
    <div className="mylearningpaths">
      <Box sx={{ padding: isMobile ? 2 : 4 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            flexDirection: isMobile ? "column" : "row",
            mb: 3
          }}
        >
          <Link to="/learners/data-science-dashboard/data-science-learningpath" style={{ textDecoration: "none" }}>
            <Box
              component="button"
              sx={{
                px: 2,
                py: 1,
                fontSize: 14,
                fontWeight: 600,
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: 2,
                color: "#052659",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#e6f0ff",
                },
              }}
            >
              ← Back to Learning Path
            </Box>
          </Link>

          {paymentStatus && (
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ color: "#052659", textAlign: isMobile ? "center" : "left" }}
            >
              Hands-On AI and ML Boot Camps
              {paymentStatus.bootcamp1 && ` - Batch ${paymentStatus.bootcamp1.slice(-3)}`}
              {paymentStatus.bootcamp1 && paymentStatus.bootcamp2 && ' & '}
              {paymentStatus.bootcamp2 && ` - Batch ${paymentStatus.bootcamp2.slice(-3)}`}
            </Typography>
          )}
        </Box>

        {loading && (
          <Box textAlign="center" mt={3}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Typography mt={2} color="error">
            {error}
          </Typography>
        )}

          {!loading && paymentStatus && (paymentStatus.bootcamp1 || paymentStatus.bootcamp2) && (
          <Box
            mt={3}
            display="flex"
            flexDirection={isMobile ? 'column' : 'row'}
            flexWrap="wrap"
            justifyContent={isMobile ? 'center' : 'start'}
            alignItems="center"
            gap={4}
          >
            {paymentStatus.bootcamp1AccessId && (
              <Card
                sx={{
                  width : isMobile ? '100%' : 300,
                  padding: '6px',
                  borderRadius: 3,
                  boxShadow: 3,
                  transition: '0.3s',
                  '&:hover': {
                    boxShadow: 6,
                  },
                }}
                variant="outlined"
              >
                <CardMedia
                  component="img"
                  height="160"
                  image={bootcamp1}
                  alt="Bootcamp 1"
                  sx={{ borderRadius: '10px' }}
                />
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Bootcamp 1
                  </Typography>
                  <SingleLogin videoUrl={paymentStatus.bootcamp1AccessId} />
                </CardContent>
              </Card>
            )}

            {paymentStatus.bootcamp2AccessId && (
              <Card
                sx={{
                  width : isMobile ? '100%' : 300,
                  padding: '6px',
                  borderRadius: 3,
                  boxShadow: 3,
                  transition: '0.3s',
                  '&:hover': {
                    boxShadow: 6,
                  },
                }}
                variant="outlined"
              >
                <CardMedia
                  component="img"
                  height="160"
                  image={bootcamp2}
                  alt="Bootcamp 2"
                  sx={{ borderRadius: '10px' }}
                />
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Bootcamp 2
                  </Typography>
                  <SingleLogin videoUrl={paymentStatus.bootcamp2AccessId} />
                </CardContent>
              </Card>
            )}
          </Box>
        )}

        {!loading &&
        paymentStatus &&
        (paymentStatus.bootcamp1 || paymentStatus.bootcamp2) &&
        (paymentStatus.bootcamp1mentorid || paymentStatus.bootcamp2mentorid) && (
          <Box mt={6}>
            <Button
              variant="contained"
              sx={{ backgroundColor: '#052659', borderRadius: '8px' }}
              onClick={handleOpenDialog}
            >
              Submit Feedback
            </Button>

            <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
              <DialogTitle sx={{ fontWeight: 600, color: '#052659' }}>
                Submit Your Feedback
              </DialogTitle>

              <DialogContent>
                <textarea
                  rows="4"
                  cols="50"
                  placeholder="Enter your feedback"
                  value={feedbackMessage}
                  onChange={(e) => setFeedbackMessage(e.target.value)}
                  style={{
                    width : '100%',
                    padding: '10px',
                    borderRadius: '8px',
                    border: '1px solid #ccc',
                    marginTop : '10px',
                  }}
                />
                <Box mt={2}>
                <Typography fontWeight={500}>Rating (1 to 5):</Typography>
                <input
                  type="number"
                  min="1"
                  max="5"
                  step="0.5"
                  value={rating}
                  onChange={(e) => setRating(parseFloat(e.target.value))}
                  style={{ width : '60px', marginLeft : '10px' }}
                />
                <Box mt={1}>{renderStars(rating)}</Box>
              </Box>
              </DialogContent>

              <DialogActions>
                <Button onClick={handleCloseDialog}>Cancel</Button>
                <Button
                  onClick={() => {
                    handleFeedbackSubmit();
                    handleCloseDialog();
                  }}
                  variant="contained"
                  sx={{ backgroundColor: '#052659' }}
                >
                  Submit
                </Button>
              </DialogActions>
            </Dialog>

            <Snackbar
            open={snackOpen}
            autoHideDuration={3000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert
              onClose={handleSnackClose}
              severity={submitStatus.includes('successfully') ? 'success' : 'error'}
            >
              {submitStatus}
            </Alert>
          </Snackbar>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default SearchLearnerTrans;








// import React from 'react';
// import { Link } from "react-router-dom";
// import { Box, Typography, Grid, Paper } from '@mui/material';
// import { Bootcamp1, BootComp2 } from './bootcomp';

// const BootComps = () => {
//   return (
//     <div className="mylearningpaths">
//     <Box sx={{ padding: 4 }}>
//       <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap", margin:"0px 0px 26px 0px" }}>
//       <Link to="/learners/data-science-dashboard/data-science-learningpath" style={{ textDecoration: "none" }}>
//         <Box
//           component="button"
//           sx={{
//             px: 2,
//             py: 1,
//             fontSize: 14,
//             fontWeight: 600,
//             backgroundColor: "#fff",
//             border: "1px solid #ccc",
//             borderRadius: 2,
//             color: "#052659",
//             cursor: "pointer",
//             "&:hover": {
//               backgroundColor: "#e6f0ff",
//             },
//           }}
//         >
//           ← Back to Learning Path
//         </Box>
//       </Link>
//       <Box>
//         <Typography
//           variant="h5"
//           fontWeight={700}
//           sx={{ color: "#052659", fontSize: { xs: "20px", sm: "20px", md: "20px" } }}
//         >
//           AI and ML Boot Camps
//         </Typography>
//       </Box>
//       </Box>
//       <Grid container spacing={4} justifyContent="center">
//         {/* Bootcamp 1 */}
//         <Grid item xs={12} md={6}>
//           <Paper elevation={3} sx={{ padding: 3, borderRadius: 3 }}>
//             <Typography variant="h6" gutterBottom fontWeight={500} textAlign={'center'}>
//               Batch 1
//             </Typography>
//             <Bootcamp1 />
//           </Paper>
//         </Grid>

//         {/* Bootcamp 2 */}
//         <Grid item xs={12} md={6}>
//           <Paper elevation={3} sx={{ padding: 3, borderRadius: 3 }}>
//             <Typography variant="h6" gutterBottom fontWeight={500} textAlign={'center'}>    
//               Batch 2
//             </Typography>
//             <BootComp2 />
//           </Paper>
//         </Grid>
//       </Grid>
//     </Box>
//     </div>
//   );
// };

// export default BootComps;
